import { SharedService } from './../../../../services/shared.service';
import {
    ChangeDetectorRef,
    Component,
    NgZone,
    OnDestroy,
    ViewChild,
    HostListener,
    Directive,
    AfterViewInit,
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { AuthenticationService } from '../../../../services/authentication.service';
import { ProfileService } from '../../../../services/profile.service';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class AppSidebarComponent implements OnDestroy {
    public config: PerfectScrollbarConfigInterface = {};
    mobileQuery: MediaQueryList;

    private _mobileQueryListener: () => void;
    status: boolean = false;
    clickEvent() {
        this.status = !this.status;
    }

    subclickEvent() {
        this.status = true;
    }
    constructor(
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        public menuItems: MenuItems,
        public sharedService: SharedService,
        public _authService: AuthenticationService,
        public _profileService: ProfileService,
    ) {
        this.mobileQuery = media.matchMedia('(min-width: 768px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        this._profileService.initProfileData();
    }


    closeSideNav() {
        if (window.innerWidth < 768) {
            this.sharedService.sideNav.close();
        }
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    logout() {
        this.closeSideNav();
        this._authService.logout();
    }
}
